import reducer from './reducer';

export { default as App } from './App';
export default reducer;
